// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { operatorId } from './Operator';
import { opKind } from './OpKind';
import { z } from 'zod';
export const harvestOperationTemplateId = (z.number());
export const harvestOperationTemplate = z.object({
    id: harvestOperationTemplateId,
    description: z.string().nullable(),
    draft_dirty: z.boolean(),
    archived_at: z.date().nullable(),
    archived_by: operatorId.nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    batch_code: z.string().nullable(),
    name: z.string(),
    icon: z.string().nullable(),
    sort_order: z.number(),
    op_kind: opKind,
});
export const harvestOperationTemplateInitializer = z.object({
    id: harvestOperationTemplateId.optional(),
    description: z.string().optional().nullable(),
    draft_dirty: z.boolean().optional(),
    archived_at: z.date().optional().nullable(),
    archived_by: operatorId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    batch_code: z.string().optional().nullable(),
    name: z.string(),
    icon: z.string().optional().nullable(),
    sort_order: z.number().optional(),
    op_kind: opKind.optional(),
});
export const harvestOperationTemplateMutator = z.object({
    id: harvestOperationTemplateId.optional(),
    description: z.string().optional().nullable(),
    draft_dirty: z.boolean().optional(),
    archived_at: z.date().optional().nullable(),
    archived_by: operatorId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    batch_code: z.string().optional().nullable(),
    name: z.string().optional(),
    icon: z.string().optional().nullable(),
    sort_order: z.number().optional(),
    op_kind: opKind.optional(),
});
//# sourceMappingURL=HarvestOperationTemplate.js.map